// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.7
//   protoc               unknown
// source: qonto/registration/partner_register/firstparty/v1/organization.proto

/* eslint-disable */
import { ApiTimestamp } from "../../../../../google/protobuf/timestamp";

/** Organization type */
export const ApiEntityType = {
  /** ENTITY_TYPE_UNSPECIFIED - Unspecified entity type */
  ENTITY_TYPE_UNSPECIFIED: "ENTITY_TYPE_UNSPECIFIED",
  /**
   * Freelancer
   */
  freelancer: "freelancer",
  /**
   * Company
   */
  company: "company",
} as const;

export type ApiEntityType = typeof ApiEntityType[keyof typeof ApiEntityType];

export namespace ApiEntityType {
  export type ENTITY_TYPE_UNSPECIFIED = typeof ApiEntityType.ENTITY_TYPE_UNSPECIFIED;
  export type freelancer = typeof ApiEntityType.freelancer;
  export type company = typeof ApiEntityType.company;
}

export function apiEntityTypeFromJSON(object: any): ApiEntityType {
  switch (object) {
    case 0:
    case "ENTITY_TYPE_UNSPECIFIED":
      return ApiEntityType.ENTITY_TYPE_UNSPECIFIED;
    case 1:
    case "freelancer":
      return ApiEntityType.freelancer;
    case 2:
    case "company":
      return ApiEntityType.company;
    default:
      return ApiEntityType.ENTITY_TYPE_UNSPECIFIED;
  }
}

export function apiEntityTypeToJSON(object: ApiEntityType): string {
  switch (object) {
    case ApiEntityType.ENTITY_TYPE_UNSPECIFIED:
      return "ENTITY_TYPE_UNSPECIFIED";
    case ApiEntityType.freelancer:
      return "freelancer";
    case ApiEntityType.company:
      return "company";
    default:
      return "ENTITY_TYPE_UNSPECIFIED";
  }
}

/** Classification of entity type for FATCA/CRS regulatory reporting */
export const ApiBusinessActivityEntityType = {
  /** BUSINESS_ACTIVITY_ENTITY_TYPE_UNSPECIFIED - Unspecified business activity entity type */
  BUSINESS_ACTIVITY_ENTITY_TYPE_UNSPECIFIED: "BUSINESS_ACTIVITY_ENTITY_TYPE_UNSPECIFIED",
  /**
   * Active Non-Financial Entity
   */
  active_nfe: "active_nfe",
  /**
   * Passive Non-Financial Entity
   */
  passive_nfe: "passive_nfe",
  /**
   * Financial Institution
   */
  financial_institution: "financial_institution",
} as const;

export type ApiBusinessActivityEntityType =
  typeof ApiBusinessActivityEntityType[keyof typeof ApiBusinessActivityEntityType];

export namespace ApiBusinessActivityEntityType {
  export type BUSINESS_ACTIVITY_ENTITY_TYPE_UNSPECIFIED =
    typeof ApiBusinessActivityEntityType.BUSINESS_ACTIVITY_ENTITY_TYPE_UNSPECIFIED;
  export type active_nfe = typeof ApiBusinessActivityEntityType.active_nfe;
  export type passive_nfe = typeof ApiBusinessActivityEntityType.passive_nfe;
  export type financial_institution = typeof ApiBusinessActivityEntityType.financial_institution;
}

export function apiBusinessActivityEntityTypeFromJSON(object: any): ApiBusinessActivityEntityType {
  switch (object) {
    case 0:
    case "BUSINESS_ACTIVITY_ENTITY_TYPE_UNSPECIFIED":
      return ApiBusinessActivityEntityType.BUSINESS_ACTIVITY_ENTITY_TYPE_UNSPECIFIED;
    case 1:
    case "active_nfe":
      return ApiBusinessActivityEntityType.active_nfe;
    case 2:
    case "passive_nfe":
      return ApiBusinessActivityEntityType.passive_nfe;
    case 3:
    case "financial_institution":
      return ApiBusinessActivityEntityType.financial_institution;
    default:
      return ApiBusinessActivityEntityType.BUSINESS_ACTIVITY_ENTITY_TYPE_UNSPECIFIED;
  }
}

export function apiBusinessActivityEntityTypeToJSON(object: ApiBusinessActivityEntityType): string {
  switch (object) {
    case ApiBusinessActivityEntityType.BUSINESS_ACTIVITY_ENTITY_TYPE_UNSPECIFIED:
      return "BUSINESS_ACTIVITY_ENTITY_TYPE_UNSPECIFIED";
    case ApiBusinessActivityEntityType.active_nfe:
      return "active_nfe";
    case ApiBusinessActivityEntityType.passive_nfe:
      return "passive_nfe";
    case ApiBusinessActivityEntityType.financial_institution:
      return "financial_institution";
    default:
      return "BUSINESS_ACTIVITY_ENTITY_TYPE_UNSPECIFIED";
  }
}

/** Organization represents an organization during the partner registration process */
export interface ApiOrganization {
  /** Unique identifier of the organization */
  readonly id: string;
  /** Organization's legal name */
  readonly legalName?:
    | string
    | null
    | undefined;
  /** Two-letter ISO 3166-1 country code */
  readonly legalCountry?:
    | string
    | null
    | undefined;
  /** Organization's legal form (e.g. SAS, SARL, GMBH, UG) */
  readonly legalForm?:
    | string
    | null
    | undefined;
  /** Organization's registration date */
  readonly legalRegistrationDate?:
    | string
    | null
    | undefined;
  /** Organization's registration number (e.g. SIRET in France) */
  readonly legalNumber?:
    | string
    | null
    | undefined;
  /** Organization legal sector code (e.g. INSEE NAF code) */
  readonly legalSector?:
    | string
    | null
    | undefined;
  /** Organization's VAT number */
  readonly legalVatNumber?:
    | string
    | null
    | undefined;
  /** Organization type */
  readonly entityType: ApiEntityType;
  /** Turnover for the past year */
  readonly annualTurnover?:
    | string
    | null
    | undefined;
  /** Estimated number of transactions per year */
  readonly yearlyTransactionVolume?:
    | string
    | null
    | undefined;
  /** Estimated highest amount for a single payment */
  readonly maxSinglePaymentAmount?:
    | number
    | null
    | undefined;
  /** Indicates what the Qonto account will be used for */
  readonly natureOfOperations: readonly string[];
  /** Creation timestamp */
  readonly createdAt:
    | Date
    | null;
  /** List of active features for the organization */
  readonly features: readonly string[];
  /** Classification of the entity type for FATCA/CRS regulatory reporting */
  readonly businessActivityEntityType: ApiBusinessActivityEntityType;
  /** Whether any beneficial owners have been declared as Politically Exposed Persons */
  readonly declaredPepInBeneficiaries: boolean;
}

export const ApiOrganization: MessageFns<ApiOrganization> = {
  fromJSON(object: any): ApiOrganization {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      legalName: isSet(object.legalName) ? globalThis.String(object.legalName) : null,
      legalCountry: isSet(object.legalCountry) ? globalThis.String(object.legalCountry) : null,
      legalForm: isSet(object.legalForm) ? globalThis.String(object.legalForm) : null,
      legalRegistrationDate: isSet(object.legalRegistrationDate)
        ? globalThis.String(object.legalRegistrationDate)
        : null,
      legalNumber: isSet(object.legalNumber) ? globalThis.String(object.legalNumber) : null,
      legalSector: isSet(object.legalSector) ? globalThis.String(object.legalSector) : null,
      legalVatNumber: isSet(object.legalVatNumber) ? globalThis.String(object.legalVatNumber) : null,
      entityType: isSet(object.entityType)
        ? apiEntityTypeFromJSON(object.entityType)
        : ApiEntityType.ENTITY_TYPE_UNSPECIFIED,
      annualTurnover: isSet(object.annualTurnover) ? globalThis.String(object.annualTurnover) : null,
      yearlyTransactionVolume: isSet(object.yearlyTransactionVolume)
        ? globalThis.String(object.yearlyTransactionVolume)
        : null,
      maxSinglePaymentAmount: isSet(object.maxSinglePaymentAmount)
        ? globalThis.Number(object.maxSinglePaymentAmount)
        : null,
      natureOfOperations: globalThis.Array.isArray(object?.natureOfOperations)
        ? object.natureOfOperations.map((e: any) => globalThis.String(e))
        : [],
      createdAt: isSet(object.createdAt) ? fromJsonTimestamp(object.createdAt) : null,
      features: globalThis.Array.isArray(object?.features) ? object.features.map((e: any) => globalThis.String(e)) : [],
      businessActivityEntityType: isSet(object.businessActivityEntityType)
        ? apiBusinessActivityEntityTypeFromJSON(object.businessActivityEntityType)
        : ApiBusinessActivityEntityType.BUSINESS_ACTIVITY_ENTITY_TYPE_UNSPECIFIED,
      declaredPepInBeneficiaries: isSet(object.declaredPepInBeneficiaries)
        ? globalThis.Boolean(object.declaredPepInBeneficiaries)
        : false,
    };
  },

  toJSON(message: ApiOrganization): unknown {
    const obj: any = {};
    if (message.id !== undefined && message.id !== null) {
      obj.id = message.id;
    }
    if (message.legalName !== undefined && message.legalName !== null) {
      obj.legalName = message.legalName;
    }
    if (message.legalCountry !== undefined && message.legalCountry !== null) {
      obj.legalCountry = message.legalCountry;
    }
    if (message.legalForm !== undefined && message.legalForm !== null) {
      obj.legalForm = message.legalForm;
    }
    if (message.legalRegistrationDate !== undefined && message.legalRegistrationDate !== null) {
      obj.legalRegistrationDate = message.legalRegistrationDate;
    }
    if (message.legalNumber !== undefined && message.legalNumber !== null) {
      obj.legalNumber = message.legalNumber;
    }
    if (message.legalSector !== undefined && message.legalSector !== null) {
      obj.legalSector = message.legalSector;
    }
    if (message.legalVatNumber !== undefined && message.legalVatNumber !== null) {
      obj.legalVatNumber = message.legalVatNumber;
    }
    if (message.entityType !== undefined && message.entityType !== null) {
      obj.entityType = apiEntityTypeToJSON(message.entityType);
    }
    if (message.annualTurnover !== undefined && message.annualTurnover !== null) {
      obj.annualTurnover = message.annualTurnover;
    }
    if (message.yearlyTransactionVolume !== undefined && message.yearlyTransactionVolume !== null) {
      obj.yearlyTransactionVolume = message.yearlyTransactionVolume;
    }
    if (message.maxSinglePaymentAmount !== undefined && message.maxSinglePaymentAmount !== null) {
      obj.maxSinglePaymentAmount = Math.round(message.maxSinglePaymentAmount);
    }
    if (message.natureOfOperations?.length) {
      obj.natureOfOperations = message.natureOfOperations;
    }
    if (message.createdAt !== undefined && message.createdAt !== null) {
      obj.createdAt = message.createdAt.toISOString();
    }
    if (message.features?.length) {
      obj.features = message.features;
    }
    if (message.businessActivityEntityType !== undefined && message.businessActivityEntityType !== null) {
      obj.businessActivityEntityType = apiBusinessActivityEntityTypeToJSON(message.businessActivityEntityType);
    }
    if (message.declaredPepInBeneficiaries !== undefined && message.declaredPepInBeneficiaries !== null) {
      obj.declaredPepInBeneficiaries = message.declaredPepInBeneficiaries;
    }
    return obj;
  },
};

function fromTimestamp(t: ApiTimestamp): Date {
  let millis = (t.seconds || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof globalThis.Date) {
    return o;
  } else if (typeof o === "string") {
    return new globalThis.Date(o);
  } else {
    return fromTimestamp(ApiTimestamp.fromJSON(o));
  }
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

interface MessageFns<T> {
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
}
